import script from "./NavbarComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavbarComp.vue?vue&type=script&setup=true&lang=ts"

import "./NavbarComp.vue?vue&type=style&index=0&id=2993e9d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2993e9d3"]])

export default __exports__